"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRefFrom;
var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));
var _react = require("react");
function useRefFrom(value) {
  var ref = (0, _react.useRef)();
  var readOnlyRef = (0, _react.useMemo)(function () {
    return (0, _create.default)({}, {
      current: {
        get: function get() {
          return ref.current;
        }
      }
    });
  }, [ref]);
  ref.current = value;
  return readOnlyRef;
}
//# sourceMappingURL=useRefFrom.js.map